import React from "react";
import { graphql } from "gatsby";
import Image from "../base/image";
import { getImage } from "gatsby-plugin-image";
import { regexValidUrl } from "../../utilities/regex";
import { kebabCase } from "../../utilities/helper";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

const Images = ({ imagesList, blockIndex = null }) => {
  const { id, images, heading, objectFit } = imagesList;

  const Anchor = imagesList?.anchor ?? kebabCase(heading) ?? id;
  const imageTitle = heading ? <h2>{heading}</h2> : "";

  useCollectAnchorLinks(heading, imagesList?.anchor, blockIndex);

  const imageList = (images) => {
    return images.map((image, index) => {
      const { title, description } = image;
      const { height, width } = getImage(image);
      return imageUrlCheck(description) ? (
        //image itself force to cover, because the parent wrapper handles its a cover or contain.
        <a
          className={`images--wrapper__container image-wrap-${images.length <= 6 ? images.length : "multi-image"} ${
            width < height ? "portrait" : "landscape"
          } images--${objectFit ? "contain" : "cover"}`}
          key={id + index}
          target="blank"
          href={description}
          id={Anchor}
        >
          {/* original: <Img
              className={`${objectFit ? "contain" : "cover"}`}
              fluid={fluid}
              objectPosition="50% 50%"
              alt={title}
            /> */}
          {/* here needs to use "cover" to offset height's width, the parent is deciding its cover or contain */}
          <Image objectFit={"cover"} imageData={image} alt={title} />
        </a>
      ) : (
        <div
          key={id + index}
          className={`images--wrapper__container image-wrap-${images.length <= 5 ? images.length : "multi-image"} ${
            width < height ? "portrait" : "landscape"
          } images--${objectFit ? "contain" : "cover"}`}
        >
          {/* original: <Img className={`${objectFit ? "contain" : "cover"}`} fluid={fluid} objectPosition="50% 50%" alt={title} /> */}
          {/* here needs to use "cover", the parent is deciding its cover or contain */}
          <Image objectFit={"cover"} imageData={image} alt={title} />
          {description ? <p className="caption">{description}</p> : ""}
        </div>
      );
    });
  };

  return images.length > 0 ? (
    <div className="images" id={Anchor}>
      {imageTitle}
      <div className="images--wrapper">{imageList(images)}</div>
    </div>
  ) : (
    ""
  );
};

export default Images;

export const query = graphql`
  fragment Images on ContentfulImage {
    id
    heading
    anchor
    objectFit
    images {
      title
      description
      ...ImageFixed
    }
  }
`;

/**
 * helper functions
 * @param {*} url
 * @returns
 */
const imageUrlCheck = (url) => regexValidUrl.test(url);
